import React from "react";
import { PRICE_MODE_OPTIONS, RETAILER_OPTIONS } from "../utils/catalogFilters";

const FILTER_LABEL_CLASS = "font-semibold text-[#24303A] text-[18px] mb-2";

function FilterChip({ active, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "shrink-0 snap-start whitespace-nowrap rounded-full px-3 py-1.5 font-bold sm:px-4 text-[15px]",
        active
          ? "border-2 border-[#7352C7] bg-[#7352C71A] text-[#7352C7]"
          : "border-2 border-[#E6EAF0] bg-white text-[#6E7B86]",
      ].join(" ")}
    >
      {label}
    </button>
  );
}

export default function RetailerPriceModeFilters({
  retailer,
  priceMode,
  onRetailerChange,
  onPriceModeChange,
  className = "",
}) {
  return (
    <div className={`space-y-3 ${className}`.trim()}>
      <div>
        <h2 className={FILTER_LABEL_CLASS}>Retailer</h2>
        <div className="-mx-1 flex snap-x snap-mandatory flex-nowrap gap-2 overflow-x-auto overscroll-x-contain px-1 pb-1 touch-pan-x [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {RETAILER_OPTIONS.map((option) => (
            <FilterChip
              key={option.id}
              label={option.label}
              active={retailer === option.id}
              onClick={() => onRetailerChange(option.id)}
            />
          ))}
        </div>
      </div>

      <div>
        <h2 className={FILTER_LABEL_CLASS}>Price Mode</h2>
        <div className="-mx-1 flex snap-x snap-mandatory flex-nowrap gap-2 overflow-x-auto overscroll-x-contain px-1 pb-1 touch-pan-x [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {PRICE_MODE_OPTIONS.map((option) => (
            <FilterChip
              key={option.id}
              label={option.label}
              active={priceMode === option.id}
              onClick={() => onPriceModeChange(option.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
